<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<div class="content">
  <div>
    <div
      class="ui basic vertical segment topic-details"
      *ngIf="modal.context.title == 'View Topic Details'"
    >
      <div>
        <h2 class="ui sub header">TOPIC</h2>
        <span>{{ data.topic }}</span>
      </div>
      <div>
        <h2 class="ui sub header">Sub-TOPICS</h2>
        <ul>
          <li *ngFor="let subtopic of data.subtopicList">
            <span>{{ subtopic.subtopic }}</span>
          </li>
        </ul>
      </div>
      <div>
        <h2 class="ui sub header">CREATED BY</h2>
        <span>{{ data.createdBy | createdBy }}</span>
      </div>
      <div>
        <h2 class="ui sub header">DATE CREATED</h2>
        <span>{{ data.dateCreated | date: "EEEE d MMMM y" }}</span>
      </div>
    </div>
    <div
      class="ui basic vertical segment subtopic-details"
      *ngIf="modal.context.title == 'View Sub-topic Details'"
    >
      <div>
        <h2 class="ui sub header">TOPIC</h2>
        <span>{{ data.topic }}</span>
      </div>
      <div>
        <h2 class="ui sub header">Sub-TOPIC</h2>
        <span>{{ data.subtopic }}</span>
      </div>
      <div>
        <h2 class="ui sub header">CREATED BY</h2>
        <span>{{ data.createdBy | createdBy }}</span>
      </div>
      <div>
        <h2 class="ui sub header">DATE CREATED</h2>
        <span>{{ data.dateCreated | date: "EEEE d MMMM y" }}</span>
      </div>
    </div>
  </div>

  <div class="actions" style="border: none">
    <button class="ui basic primary button" (click)="modal.deny(undefined)">
      Back
    </button>
  </div>
</div>
